import type { PropsWithChildren, ReactNode } from "react";

import type { IStatusChipProps } from "app/pages/sales-intelligence/common-components/StatusChip/StatusChip";
import { StatusChip } from "app/pages/sales-intelligence/common-components/StatusChip/StatusChip";
import type { IManagementCardHeaderProps } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardHeader";
import ManagementCardHeader from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardHeader";

import {
    StyledManagementCardBodySlot,
    StyledManagementCardFooterSlot,
    StyledManagementCardGridWrapper,
    StyledManagementCardHeaderSlot,
} from "./styles";

export interface IManagementCardProps
    extends IManagementCardHeaderProps, Pick<IStatusChipProps, "chipType" | "tooltipText"> {
    dataAutomation?: string;
    headerBadge?: ReactNode;
    isStatusInProgress?: boolean;
    chipText?: string;
    footer?: ReactNode;
}

const ManagementCard = ({
    dataAutomation,
    chipText,
    chipType = "success",
    headerBadge,
    isStatusInProgress,
    tooltipText,
    footer,
    children,
    ...headerProps
}: PropsWithChildren<IManagementCardProps>) => {
    return (
        <StyledManagementCardGridWrapper data-automation={dataAutomation}>
            <StyledManagementCardHeaderSlot>
                <ManagementCardHeader {...headerProps}>
                    {headerBadge}
                    {chipText ? (
                        <StatusChip
                            isLoading={isStatusInProgress}
                            chipType={chipType}
                            tooltipText={tooltipText}
                        >
                            {chipText}
                        </StatusChip>
                    ) : null}
                </ManagementCardHeader>
            </StyledManagementCardHeaderSlot>

            {children ? <StyledManagementCardBodySlot>{children}</StyledManagementCardBodySlot> : null}

            {footer ? <StyledManagementCardFooterSlot>{footer}</StyledManagementCardFooterSlot> : null}
        </StyledManagementCardGridWrapper>
    );
};

export default ManagementCard;
